import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Input } from '../../components/primitives';
import { AuthLayout } from './AuthLayout';
import { api } from '../../lib/api';
import { apiErrorMessage } from './authMessages';
import styles from './AuthPages.module.css';

interface ForgotPasswordResponse {
  status: string;
  message?: string;
}

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setSubmitting(true);
    try {
      const res = await api.post<ForgotPasswordResponse>('/auth/forgot-password', { email });
      setMessage(
        res.message ?? 'Pokud e‑mail existuje, poslali jsme na něj odkaz pro obnovu hesla.',
      );
    } catch (err) {
      setError(apiErrorMessage(err, 'Odeslání odkazu se nezdařilo.'));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout subtitle="Obnova zapomenutého hesla">
      <Card>
        <form className={styles.form} onSubmit={handleSubmit} noValidate>
          {error && (
            <div className={styles.error} role="alert">
              {error}
            </div>
          )}
          {message && (
            <div className={styles.success} role="status">
              {message}
            </div>
          )}

          <Input
            label="E‑mail"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="vas@email.cz"
          />

          <Button type="submit" variant="primary" size="lg" fullWidth disabled={submitting}>
            {submitting ? 'Odesílám…' : 'Odeslat odkaz na e‑mail'}
          </Button>

          <div className={styles.switch}>
            <Link to="/login" className={styles.link}>
              ← Zpět na přihlášení
            </Link>
          </div>
        </form>
      </Card>
    </AuthLayout>
  );
}
